<script setup lang="ts">
import { LogOut, ShieldCheck, UserRound } from '@lucide/vue';
import { BUILD_CONFIG, APP_MODE, APP_VERSION } from '@/config/buildConfig';
import { currentSession, clearSession } from '@/auth/session';
import { useRouter } from 'vue-router';

const router = useRouter();
const appName = BUILD_CONFIG.branding?.appName ?? '力聚售后管理后台';

async function logout() {
  clearSession();
  await router.push('/login');
}
</script>

<template>
  <header class="top-bar">
    <div class="brand">
      <div
        class="brand-mark"
        aria-hidden="true"
      >
        <ShieldCheck :size="18" />
      </div>
      <div class="brand-copy">
        <strong>{{ appName }}</strong>
        <span class="env">{{ APP_MODE }} · {{ APP_VERSION }}</span>
      </div>
    </div>
    <div class="actions">
      <div
        v-if="currentSession"
        class="user"
      >
        <UserRound :size="16" />
        <span>{{ currentSession?.userName }}</span>
      </div>
      <button
        v-if="currentSession"
        type="button"
        @click="logout"
      >
        <LogOut :size="15" />
        退出
      </button>
    </div>
  </header>
</template>

<style scoped>
.top-bar {
  position: sticky;
  top: 0;
  z-index: 20;
  height: 56px;
  flex: 0 0 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px;
  background: rgba(255, 255, 255, 0.96);
  color: #0f172a;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}
.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.brand-mark {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #1677ff;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(22, 119, 255, 0.2);
}
.brand-copy {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}
.brand-copy strong {
  font-weight: 600;
  white-space: nowrap;
}
.env {
  font-size: 12px;
  color: #64748b;
  font-weight: 400;
  white-space: nowrap;
}
.actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.user {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 220px;
  color: #334155;
  font-size: 13px;
  white-space: nowrap;
}
button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  background: #ffffff;
  color: #334155;
  border: 1px solid #d9e2ec;
  padding: 0 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: color 0.16s ease, border-color 0.16s ease, background 0.16s ease;
}
button:hover {
  color: #1677ff;
  border-color: #91caff;
  background: #f0f7ff;
}
</style>
